module.exports = __webpack_public_path__ + "static/media/pdf.6f0c0998.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pdf.svg
// module id = 244
// module chunks = 0